import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import './ResetModal.css';

interface ResetModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export function ResetModal({ isOpen, onConfirm, onCancel, isLoading = false }: ResetModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} title="Confirmar Reset da Partida">
      <div className="reset-modal-content">
        <p className="reset-modal-message">
          Tem certeza que deseja reiniciar a partida? Esta ação irá zerar todos os pontos e sets.
        </p>

        <div className="reset-modal-actions">
          <Button variant="outline" onClick={onCancel} disabled={isLoading}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={onConfirm} isLoading={isLoading}>
            Confirmar Reset
          </Button>
        </div>
      </div>
    </Modal>
  );
}
